import type { ApiRoute, NoPathParams, NoQueryParams } from "../api"
import type { CreateVehicleShareLinkBody } from "./CreateVehicleShareLinkBody"
import type { VehicleShareLinkView } from "./VehicleShareLinkView"

export const createVehicleShareLinkRoute: ApiRoute<
	NoPathParams,
	NoQueryParams,
	CreateVehicleShareLinkBody,
	VehicleShareLinkView
> = {
	buildUrl: () => "/vehicle-sharing/share-link",
	method: "post",
	path: "/vehicle-sharing/share-link",
}
